vue.<template>
  <section>
      <div class="container">
          <form id="filter">
            <div :class="(selectedType != 'clientes' && selectedType != 'tecnicos' ? 'dateFilterBig' : 'dateFilterSmall')" id="dateFilter">
                <div :class="(selectedType != 'clientes' && selectedType != 'tecnicos' ? 'inputGroupBig' : 'inputGroupSmall')">
                    <label style="margin: 5px" for="startDate">Data Inicial:</label>
                    <input name="startDate" class="dateInput form-control" type="datetime-local" v-model="startDate" required>
                </div>
                <div :class="(selectedType != 'clientes' && selectedType != 'tecnicos' ? 'inputGroupBig' : 'inputGroupSmall')">
                    <label style="margin: 5px" for="endDate">Data Final: </label>
                    <input name="endDate" class="dateInput form-control" type="datetime-local" v-model="endDate" required>
                </div>
            </div>
            <div  v-if="selectedType == 'clientes'"  class="selectFilter" id="selectFilter">
                <select class="selects form-control" id="selectClient" v-model="selectClient" multiple>
                    <option v-for="(item, index) in clientList" :key="index" :value="item">{{item.fantasy_name}}</option>
                </select>
                <div style="display: flex; flex-direction: column; margin: 5px">
                    <button type="button" class="btn btn-primary btn-select" @click="addOne" ><i class="fa fa-angle-right" aria-hidden="true"></i></button>
                    <button type="button" class="btn btn-primary btn-select" @click="addAll"><i class="fa fa-angle-double-right" aria-hidden="true"></i></button>
                    <button type="button" class="btn btn-primary btn-select" @click="removeOne"><i class="fa fa-angle-left" aria-hidden="true"></i></button>
                    <button type="button" class="btn btn-primary btn-select" @click="removeAll"><i class="fa fa-angle-double-left" aria-hidden="true"></i></button>
                </div>
                <select class="selects form-control" name="selectedValues" id="selectedValues" v-model="selectedValuesC" multiple>
                    <option v-for="(item, index) in selectedClients" :key="index" :value="item.id">{{item.fantasy_name}}</option>
                </select>
            </div>
            <div  v-if="selectedType == 'tecnicos'" class="selectFilter" id="selectFilter">
                <select  v-if="selectedType == 'tecnicos'" class="selects form-control" id="selectTech" v-model="selectTech" multiple>
                    <option v-for="(item, index) in techList" :key="index" :value="item">{{item.name}}</option>
                </select>
                <div style="display: flex; flex-direction: column; margin: 5px">
                    <button type="button" class="btn btn-primary btn-select" @click="addOne"><i class="fa fa-angle-right" aria-hidden="true"></i></button>
                    <button type="button" class="btn btn-primary btn-select" @click="addAll"><i class="fa fa-angle-double-right" aria-hidden="true"></i></button>
                    <button type="button" class="btn btn-primary btn-select" @click="removeOne"><i class="fa fa-angle-left" aria-hidden="true"></i></button>
                    <button type="button" class="btn btn-primary btn-select" @click="removeAll"><i class="fa fa-angle-double-left" aria-hidden="true"></i></button>
                </div>
                <select class="selects form-control" name="selectedValues" id="selectedValues" v-model="selectedValuesT" multiple>
                    <option v-for="(item, index) in selectedTechs" :key="index" :value="item.id">{{item.name}}</option>
                </select>
            </div>
            <div :class="(selectedType != 'clientes' && selectedType != 'tecnicos' ? 'typeFilterBig' : 'typeFilterSmall')" id="typeFilter">
                <label for="typeSelect">Tipo de Relatório</label>
                <select class="form-control" id="typeSelect" aria-label="Tipo" aria-describedby="typeSelect" v-model="selectedType">
                    <option disabled value="">Selecione</option>
                    <optgroup label="Ligações">
                        <option value="entrantes" selected>Ligações Entrantes</option>
                        <option value="saintes">Ligações Saíntes</option>
                        <option value="transferidas">Ligações Transferidas</option>
                        <option value="naoAtendidas">Ligações Não Atendidas/Abandonadas</option>
                    </optgroup>
                    <optgroup label="Pesquisa">
                        <option value="pesquisaTi">Pesquisa Log</option>
                        <option value="insatisfaction">Relatório de Insatisfação</option>
                        <option value="products">Relatório de Produtos</option>
                    </optgroup>
                    <optgroup label="Operadores">
                        <!-- <option value="produtividade" disabled>Produtividade</option> -->
                        <option value="pausas">Pausas</option>
                        <!-- <option value="kpi">Indicadores de Performance (KPI)</option> -->
                    </optgroup>

                    <optgroup label="Chamados">
                        <option value="clientes" hideQueuesExtensions="true" >Clientes</option>
                        <option value="tecnicos" hideQueuesExtensions="true" >Tecnicos</option>
                    </optgroup> 
                </select>
                <div id="buttonDiv">
                    <button type="submit" id="submitButton" class="btn btn-primary"><i class="fa fa-search" aria-hidden="true"></i>  Pesquisar</button>
                    <button type="button" class="btn btn-secondary"  @click="resetForm"><i class="fa fa-times" aria-hidden="true"></i> Resetar</button>
                </div>
            </div>
          </form>
      </div>
  </section>
</template>

<script>
import '../../modules/reports/reports.js';

export default {
    data() {
        return {
            selectedType: '',
            startDate: '',
            endDate: '',
            techList: '',
            clientList: '',
            selectTech: [],
            selectClient: [],
            selectedTechs: [],
            selectedClients: [],
            selectedValuesC: [],
            selectedValuesT: []
        }
    },

    created() {
        this.getTech()
        this.getClients()
    },

    mounted() {
        console.log('2')
    },

    watch: {
        selectedType: function() {
            console.log(this.selectedType)
            this.selectTech = [],
            this.selectClient = [],
            this.selectedTechs = [],
            this.selectedClients = [],
            this.selectedValuesC = [],
            this.selectedValuesT = []
        }

    },

    methods: {
        getTech: function(){
            axios.get('/user/listOperators') 
            .then( (data) => { 
            this.techList = data.data;
            })
            .catch( (err) => { 
                console.log(err);
            })
        },
        getClients: function(){
            axios.get('/customer_base/getWallets')
            .then( (data) => { 
            this.clientList = data.data;
            })
            .catch( (err) => { 
                console.log(err);
            })
        },
        addOne: function(){
            if(this.selectedType == 'clientes'){
                this.selectClient.forEach(element => {
                    if(!this.selectedClients.includes(element)){
                        this.selectedClients.push(element)
                    }
                });
            } else if(this.selectedType == 'tecnicos'){
                this.selectTech.forEach(element => {
                    if(!this.selectedTechs.includes(element)){
                        this.selectedTechs.push(element)
                    }
                });
            }
        },
        addAll: function(){
            if(this.selectedType == 'clientes'){
                this.clientList.forEach(element => {
                    if(!this.selectedClients.includes(element)){
                        this.selectedClients.push(element)
                    }
                });
            } else if(this.selectedType == 'tecnicos'){
                this.techList.forEach(element => {
                    if(!this.selectedTechs.includes(element)){
                        this.selectedTechs.push(element)
                    }
                });
            }
        },
        removeOne: function(){
            if(this.selectedType == 'clientes'){
                if(this.selectedClients != []){
                    this.selectedValuesC.forEach(element => {
                        const index = this.selectedClients.findIndex(el => el.id == element)
                        this.selectedClients.splice(index, 1)
                    });
                }
            } else if(this.selectedType == 'tecnicos'){
                if(this.selectedTechs != []){
                    this.selectedValuesT.forEach(element => {
                        const index = this.selectedTechs.findIndex(el => el.id == element)
                        this.selectedTechs.splice(index, 1)
                    });
                }
            }
        },
        removeAll: function(){
            this.selectedClients = []
            this.selectedTechs = []
        },

        resetForm: function(){
            this.startDate = '',
            this.endDate = '',
            this.selectTech = [],
            this.selectClient = [],
            this.selectedTechs = [],
            this.selectedClients = [],
            this.selectedValuesC = [],
            this.selectedValuesT = []
        }
    },
}
</script>

<style scoped>
    .container {
        background-color: #1c869a1c;
        border-radius: 20px;
    }

    .selects {
        margin: 5px;
        outline: none;
        width: 200px;
    }

    .btn-select {
        margin: 5px;
    }

    .inputGroupBig {
        width: 40%;
        margin: 30px;
    }

    .inputGroupBig {
        width: 100%;
    }
    
    .dateInput{
        margin: 5px;
        outline: none;
    }

    #buttonDiv {
        margin: 5px;
    }

    .dateFilterBig {
        display: flex;
        margin: 5px;
        flex-direction: row;
        justify-content: space-evenly;
        flex: 2;
        align-items: center;
    }

    .dateFilterSmall {
        display: flex;
        margin: 5px;
        flex-direction: column;
        justify-content: center;
        flex: 1;
    }

    .selectFilter {
        display: flex;
        margin: 5px;
        justify-content: center;
        flex: 3;
    }

    .typeFilterSmall {
        display: flex;
        flex-direction: column;
        margin: 5px;
        justify-content: space-evenly;
        flex: 2;
        text-align: center;
    }
    .typeFilterBig {
        display: flex;
        flex-direction: column;
        margin: 5px;
        justify-content: space-evenly;
        flex: 1;
        text-align: center;
        align-items: center;
    }

    #typeSelect{
        margin: 5px;
    }

    #dateFilter {
        border-right: solid 1px lightgray;
        padding: 20px;
    }

    #selectFilter {
        border-right: solid 1px lightgray;
        padding: 10px;
    }

    #typeFilter {
        padding: 10px;
    }

    form {
        display: flex;
    }

    label {
        font-weight: bold;
    }
</style>
